import React, { Component } from 'react';
import svgLogo from '../assets/logow.svg'
import './Footer.css';

class Footer extends Component {
  render() {
    return (
      <footer className="app_footer">
      <div className="foot_cp">Copyright © 2020 HiFineApp</div>
      <div className="foot_pp"><a href={process.env.PUBLIC_URL + "/privacypolicy.htm"} target="_blank" rel="noopener noreferrer">Privacy Policy</a></div>
      <div className="foot_cu"><a href={this.props.mailto}>Contact us</a></div>
      <img src={svgLogo} className="foot_logo" alt="HiFineApp" title="HiFineApp" />
      </footer>
    );
  }
}

export default Footer;
